<template>
  <div v-loading="!dataList">
    <!-- NOTE: 空数据情况: 开发人员根据业务调整 -->
    <template v-if="total == 0 && !isSearch">
      <StdNullPage text="您还没有现金红包，快来创建吧！" :nullType="'nullData'">
        <vh-button size="medium" type="primary" round @click="edit">创建</vh-button>
      </StdNullPage>
    </template>

    <!-- 非空数据情况 -->
    <template v-else>
      <!-- NOTE: 搜索栏: 开发人员根据业务调整  -->
      <StdSearchBar v-model="keyword" placeholder="请输入标题" @search="handleSearch">
        <vh-button size="medium" type="primary" round @click="edit">创建</vh-button>
        <vh-button
          size="medium"
          type="info"
          @click="del(multipleSelection.map(el => el.id).join(','))"
          round
          plain
          :disabled="multipleSelection.length === 0"
        >
          批量删除
        </vh-button>
      </StdSearchBar>

      <!-- NOTE: 表格数据: 开发人员根据业务调整  -->
      <vh-table
        :data="dataList"
        style="width: 100%"
        @cell-mouse-enter="handleCellMouseEnter"
        @cell-mouse-leave="handleCellMouseLeave"
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <StdNullPage text="暂未搜索到您想要的内容" :nullType="'search'"></StdNullPage>
        </template>
        <!-- 多选 -->
        <vh-table-column
          type="selection"
          :selectable="
            row => {
              return row.status == 1;
            }
          "
          width="55"
          fixed="left"
        />
        <vh-table-column label="标题" min-width="160">
          <template slot-scope="scope">
            <vh-tooltip effect="dark" placement="top-start" :content="scope.row.title">
              <div class="custom-tooltip-content two-lines-ellipsis">{{ scope.row.title }}</div>
            </vh-tooltip>
          </template>
        </vh-table-column>
        <vh-table-column prop="active_rule_cardinal" label="参与条件" width="100">
          <template slot-scope="scope">
            {{
              scope.row.active_rule_cardinal == 1 ? '无条件' : `观看${scope.row.watch_minute}分钟`
            }}
          </template>
        </vh-table-column>
        <vh-table-column prop="grant_type" label="发放模式" width="100">
          <template slot-scope="scope">
            {{ scope.row.grant_type == 1 ? '固定金额' : '随机金额' }}
          </template>
        </vh-table-column>
        <vh-table-column prop="total_amount" label="总金额（元）" width="110">
          <template slot-scope="scope">
            {{
              scope.row.grant_type == 1
                ? (scope.row.each_amount * scope.row.red_packet_num) / 100
                : scope.row.total_amount / 100
            }}
          </template>
        </vh-table-column>
        <vh-table-column prop="red_packet_num" width="80" label="红包个数">
          <template slot-scope="scope">
            {{ scope.row.red_packet_num || '-' }}
          </template>
        </vh-table-column>
        <vh-table-column label="单个金额（元）" width="130">
          <template slot-scope="scope">
            {{
              scope.row.each_amount && scope.row.grant_type == 1 ? scope.row.each_amount / 100 : '-'
            }}
          </template>
        </vh-table-column>
        <vh-table-column prop="grant_num" label="领取人数" width="80">
          <template slot-scope="scope">
            <vh-button type="text" @click="toRecord(scope.row)">
              {{ scope.row.grant_num > 0 ? scope.row.grant_num : '-' }}
            </vh-button>
          </template>
        </vh-table-column>
        <vh-table-column prop="num" label="推送方式" width="80">
          <template slot-scope="scope">
            {{ scope.row.active_rule_cardinal == 1 ? '手动推送' : '自动推送' }}
          </template>
        </vh-table-column>
        <vh-table-column prop="num" label="状态" width="80">
          <template slot-scope="scope">
            {{
              scope.row.active_rule_cardinal == 1 || scope.row.status == 3
                ? statusMap[scope.row.status]
                : '自动推送'
            }}
          </template>
        </vh-table-column>
        <vh-table-column prop="update_time" label="最后操作时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at | dateFormat('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </vh-table-column>
        <!-- 操作 -->
        <vh-table-column label="操作" :width="source == 'live' ? '160' : '120'" fixed="right">
          <template slot-scope="scope">
            <template v-if="source == 'live' && scope.row.status != 3">
              <vh-button
                type="text"
                v-if="scope.row.status == 1 && scope.row.type == 1"
                @click="pushRedPacket(scope.row)"
              >
                推送
              </vh-button>
              <vh-button type="text" v-if="scope.row.status == 2" @click="endRedPacket(scope.row)">
                结束
              </vh-button>
            </template>
            <vh-button type="text" :disabled="scope.row.status != 1" @click="edit(scope.row)">
              编辑
            </vh-button>
            <vh-button type="text" :disabled="scope.row.status != 1" @click="del(scope.row.id)">
              删除
            </vh-button>
          </template>
        </vh-table-column>
      </vh-table>

      <!-- NOTE: 分页: 开发人员根据业务调整  -->
      <StdPagination
        :total="total || 0"
        :page-size="pagination.limit"
        :currentPage="pagination.pageNo"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </template>
  </div>
</template>

<script>
  import { tableCellTooltip } from '@vhcl/ui-console';
  import { StdNullPage, StdSearchBar, StdPagination } from '@vhcl/ui-console';
  import { getRedPacketList, delRedPacket, pushRedPacket, endRedPacket } from '../common/api';
  export default {
    mixins: [tableCellTooltip],
    components: {
      StdNullPage,
      StdSearchBar,
      StdPagination
    },
    props: {
      webinarId: {},
      type: {},
      source: {
        default: 'admin' //live:发起端，admin:控制台
      }
    },
    data() {
      return {
        isNoData: false,

        keyword: '',
        multipleSelection: [],
        dataList: '',
        total: 0, // 总数量
        isEmpty: false,
        selectId: '',
        // 分页参数
        pagination: {
          limit: 10,
          pageNo: 1
        },
        statusMap: {
          1: '未推送',
          2: '已推送',
          3: '已结束'
        },
        isSearch: false
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      getStatusDotType(val) {
        if (val === 1) return 'doing';
        if (val == 2) return 'success';
        return 'pending';
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      async handleSearch() {
        console.log('======ok===');

        this.pagination.pageNo = 1;
        await this.fetchData();
        this.isSearch = this.keyword.trim() != '';
      },
      // 翻页事件
      handleCurrentChange(current) {
        this.pagination.pageNo = current; //当前页码
        this.fetchData();
      },
      // 每页条数改变时触发
      handleSizeChange(limit) {
        this.pagination.limit = limit;
        this.pagination.pageNo = 1;
        this.fetchData();
      },
      // 模拟请求数据
      fetchData: async function () {
        // this.loading = true;
        this.keyword = this.keyword.trim();
        const res = await getRedPacketList({
          keyword: this.keyword,
          webinar_id: this.webinarId,
          type: this.type,
          pos: (this.pagination.pageNo - 1) * this.pagination.limit,
          limit: this.pagination.limit
        });
        if (res.code == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        }
      },
      handleCommand({ cmd, row }) {
        console.log(dataJson);
      },
      edit(data) {
        if (!data && this.total >= 1000) {
          this.$message({
            type: 'warning',
            message: '最多可创建1000个'
          });
          return;
        }
        this.$emit('edit', data);
      },
      toRecord(data) {
        this.$emit('toRecord', data);
      },
      del(ids) {
        (this.$vhConfirm || this.$confirm)('删除后，当前内容将无法使用，确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton: true
        }).then(() => {
          delRedPacket({ ids }).then(res => {
            if (res.code == 200) {
              this.pagination.pageNo = 1;
              this.fetchData();
              (this.$vhMessage || this.$message)({
                type: 'success',
                message: '删除成功'
              });
            } else {
              (this.$vhMessage || this.$message)({
                type: 'error',
                message: res.msg
              });
            }
          });
        });
      },
      pushRedPacket(data) {
        pushRedPacket({ id: data.id }).then(res => {
          if (res.code == 200) {
            (this.$vhMessage || this.$message)({
              type: 'success',
              message: '推送成功'
            });
            this.fetchData();
          } else {
            (this.$vhMessage || this.$message)({
              type: 'error',
              message: res.msg
            });
          }
        });
      },
      endRedPacket(data) {
        (this.$vhConfirm || this.$confirm)('观众将无法领取红包，确认结束？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton: true
        }).then(() => {
          endRedPacket({ id: data.id }).then(res => {
            if (res.code == 200) {
              (this.$vhMessage || this.$message)({
                type: 'success',
                message: '结束成功'
              });
              this.fetchData();
            } else {
              (this.$vhMessage || this.$message)({
                type: 'error',
                message: res.msg
              });
            }
          });
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .two-lines-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
</style>
